import Image from 'next/image';

import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';

import { GlImage } from '../../Image';
import { Box } from '../../Box';

export const MobileImage = styled(GlImage)`
  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopImage = styled(GlImage)<{
  visibility: string;
}>`
  visibility: ${({ visibility }) => visibility};
  border-radius: ${({ theme }) => theme.borderRadius.milestoneShape};
`;

export const VerticalDivider = styled('div')`
  margin: auto ${({ theme }) => theme.spacing.s};
  max-height: ${pxToRem(56)};

  ${mediaQueries.desktop} {
    margin: auto ${({ theme }) => theme.spacing.sm};
    max-height: ${pxToRem(62)};
  }
`;

export const LogoContainer = styled('div')<{
  useGreenlightIcon?: boolean | null;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: ${pxToRem(88)};
  width: 90%;
  margin: auto;
  justify-content: center;

  ${mediaQueries.tablet} {
    justify-content: flex-start;
    margin: 0;
  }

  ${mediaQueries.desktop} {
    min-height: auto;
  }
`;

export const PositionerBox = styled(Box)<{
  useGreenlightIcon?: boolean | null;
}>`
  display: ${({ useGreenlightIcon }) => (useGreenlightIcon ? 'flex' : 'block')};
  flex: 0.1 1 auto;
  justify-content: ${({ useGreenlightIcon }) =>
    useGreenlightIcon ? 'center' : 'auto'};

  ${mediaQueries.desktop} {
    justify-content: ${({ useGreenlightIcon }) =>
      useGreenlightIcon ? 'flex-start' : 'auto'};
    flex: none;
  }
`;

export const StyledGreenlightIcon = styled(Image)`
  max-width: 100%;
  margin: auto;

  ${mediaQueries.desktop} {
    margin: 0;
  }
`;

export const AffiliateLogo = styled('img')<{
  logoHeight: string;
}>`
  max-height: ${({ logoHeight }) => logoHeight};
  max-width: 100%;
`;
